module.exports = __webpack_public_path__ + "static/media/benefit_2.1bd1f554.JPG";